export const POSITION_ISSUE_TYPE_NAME_INPUT = 'issue-type-name-input';
export const POSITION_ISSUE_TYPE_HELP_TEXT_INPUT = 'issue-type-help-text-input';
export const POSITION_ISSUE_TYPE_DESCRIPTION_INPUT = 'issue-type-description-input';

export const POSITION_FIELD_NAME_INPUT = 'field-name-input' as const;
export const POSITION_FIELD_OPTIONS = 'field-options' as const;
export const POSITION_FIELD_DEFAULT_VALUE_INPUT = 'field-default-value-input' as const;
export const POSITION_FIELD_DESCRIPTION_INPUT = 'field-description-input' as const;
export const POSITION_INACTIVE_LAYOUT_ITEM = 'inactive-layout-item' as const;

export const ISSUE_TYPE_NAME_VALIDATOR = 'issueTypeNameValidator';
export const ISSUE_TYPE_HELP_TEXT_VALIDATOR = 'issueTypeHelpTextValidator';
export const ISSUE_TYPE_DESCRIPTION_VALIDATOR = 'issueTypeDescriptionValidator';
